var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeDropdownNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 68,
    viewBox: "0 0 98 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3488_5924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 58,
    height: 28,
    rx: 14,
    fill: "#E6FFEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 20.75,
    width: 56.5,
    height: 26.5,
    rx: 13.25,
    stroke: "#2DD95B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 33.9993C31.3333 33.263 31.9302 32.666 32.6666 32.666C33.7712 32.666 34.6666 33.5614 34.6666 34.666V37.3327C34.6666 38.4373 33.7712 39.3327 32.6666 39.3327C31.9302 39.3327 31.3333 38.7357 31.3333 37.9993V33.9993Z",
    fill: "#E5FFEC",
    stroke: "#2DD95B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3192 30.8708L40.1417 31.4442C39.9962 31.9141 39.9235 32.149 39.9794 32.3345C40.0247 32.4846 40.124 32.614 40.2594 32.6991C40.4268 32.8044 40.6799 32.8044 41.1862 32.8044H41.4555C43.1689 32.8044 44.0255 32.8044 44.4302 33.3115C44.4764 33.3695 44.5176 33.4311 44.5531 33.4958C44.8644 34.0614 44.5105 34.8234 43.8027 36.3474C43.1532 37.7459 42.8284 38.4452 42.2254 38.8568C42.1671 38.8966 42.1071 38.9342 42.0456 38.9694C41.4108 39.3333 40.6242 39.3333 39.051 39.3333H38.7098C36.8039 39.3333 35.8509 39.3333 35.2588 38.7596C34.6667 38.186 34.6667 37.2626 34.6667 35.416V34.7669C34.6667 33.7964 34.6667 33.3112 34.839 32.8671C35.0112 32.4229 35.341 32.0578 36.0005 31.3274L38.7282 28.307C38.7966 28.2313 38.8308 28.1934 38.8609 28.1672C39.1424 27.9222 39.5769 27.9498 39.823 28.2282C39.8494 28.2581 39.8782 28.2999 39.9358 28.3837C40.026 28.5147 40.071 28.5802 40.1103 28.6451C40.462 29.2261 40.5684 29.9162 40.4073 30.5714C40.3893 30.6446 40.3659 30.7201 40.3192 30.8708Z",
    fill: "#E5FFEC",
    stroke: "#2DD95B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3488_5924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0013 32C64.5693 32 64.8659 32.6573 64.5233 33.082L64.4726 33.138L60.4726 37.138C60.3578 37.2528 60.2051 37.3217 60.0431 37.3319C59.881 37.3421 59.7209 37.2928 59.5926 37.1933L59.5299 37.138L55.5299 33.138L55.4746 33.0753L55.4386 33.024L55.4026 32.96L55.3913 32.936L55.3733 32.8913L55.3519 32.8193L55.3453 32.784L55.3386 32.744L55.3359 32.706V32.6273L55.3393 32.5887L55.3453 32.5487L55.3519 32.514L55.3733 32.442L55.3913 32.3973L55.4379 32.3093L55.4813 32.2493L55.5299 32.1953L55.5926 32.14L55.6439 32.104L55.7079 32.068L55.7319 32.0567L55.7766 32.0387L55.8486 32.0173L55.8839 32.0107L55.9239 32.004L55.9619 32.0013L64.0013 32Z",
    fill: "#2DD95B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3488_5924",
    x: 0,
    y: 0,
    width: 98,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3488_5924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3488_5924",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3488_5924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(52 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDropdownNew);
export default __webpack_public_path__ + "static/media/likeDropdownNew.9ea19a1544c32d6b8fa7de4148a46be3.svg";
export { ForwardRef as ReactComponent };